import { useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { rsFr } from "./ChallengeShell";

const Row = ({ l, v, testid }) => v ? <div className="py-2.5" data-testid={testid}><div className="text-xs font-bold text-[#7D8C96] uppercase">{l}</div><div className="text-[15px] text-[#13283A] mt-0.5 whitespace-pre-wrap">{v}</div></div> : null;

export function IdeaBrief({ brief, tier, builder, plan: initial }) {
  const [plan, setPlan] = useState(initial || "");
  const [busy, setBusy] = useState(false);
  const gen = async () => {
    setBusy(true);
    try { setPlan((await api.post("/challenge/builder-plan")).data.text); } catch (e) { toast.error(e?.response?.data?.detail || "Réessaie dans un instant."); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-3">
      <div className="rounded-3xl bg-white border-2 border-[#13B698] p-5 divide-y divide-[#E1ECEF]" data-testid="idea-brief">
        <Row l="Idée de business" v={brief.idea} testid="brief-idea" />
        <Row l="Clients ciblés" v={brief.target} testid="brief-target" />
        <Row l="Première offre" v={brief.offer} testid="brief-offer" />
        <Row l="Hypothèse de prix" v={brief.price} testid="brief-price" />
        <Row l="Retours clients" v={[brief.feedback, brief.feedback_summary].filter(Boolean).join("\n")} testid="brief-feedback" />
        <Row l="Décision" v={brief.decision} testid="brief-decision" />
        <Row l="Ce qu’il reste à vérifier" v={brief.uncertainties?.map((u) => `• ${u}`).join("\n")} testid="brief-uncertainties" />
        <Row l="Mes 3 prochaines actions" v={brief.actions?.map((a, i) => `${i + 1}. ${a}`).join("\n")} testid="brief-actions" />
        <Row l="Objectif des 7 prochains jours" v={brief.goal} testid="brief-goal" />
      </div>
      {tier === "builder" ? (
        <div className="rounded-3xl bg-[#13283A] text-white p-5" data-testid="builder-plan-box">
          <div className="font-display font-bold flex items-center gap-2"><Sparkles className="h-5 w-5 text-[#13B698]" />Mon plan détaillé Business Builder</div>
          {plan ? <p className="text-sm text-white/90 mt-3 whitespace-pre-wrap" data-testid="builder-plan-text">{plan}</p> : <p className="text-sm text-white/75 mt-2">Transforme ton Idea Brief en budget à chiffrer, plan sur 30 jours et risques à tester.</p>}
          <div className="flex flex-wrap gap-2 mt-4">
            <button disabled={busy} onClick={gen} className="min-h-[48px] px-5 rounded-2xl bg-[#13B698] font-bold" data-testid="builder-plan-generate">{busy ? "Préparation…" : plan ? "Mettre à jour mon plan" : "Préparer mon plan détaillé"}</button>
            <Link to="/launch" className="min-h-[48px] px-5 rounded-2xl border border-white/30 font-bold inline-flex items-center" data-testid="builder-launch-link">Ouvrir mon plan de lancement</Link>
          </div>
          <p className="text-xs text-white/60 mt-3">Les coûts et démarches officielles à Maurice restent à vérifier auprès des sources officielles.</p>
        </div>
      ) : builder && (
        <div className="rounded-3xl bg-[#F4F8F9] border border-[#E1ECEF] p-5" data-testid="brief-builder-offer">
          <div className="font-display font-bold text-[#13283A]">PLAN 30 JOURS • {rsFr(builder.price)}{builder.credit ? ` (crédit guide de ${rsFr(builder.credit)} appliqué)` : "/an"}</div>
          <p className="text-sm text-[#36495A] mt-1">Ton Idea Brief est prêt. Passe au plan personnalisé sur 30 jours avec Business Builder.</p>
          <div className="flex flex-wrap gap-3 mt-3 items-center">
            <Link to="/challenge/builder" className="min-h-[48px] px-5 rounded-2xl bg-[#13283A] text-white font-bold inline-flex items-center" data-testid="brief-builder-cta">Construire mon business</Link>
            <span className="text-sm text-[#5C6B73]">ou conserve ton résumé gratuit</span>
          </div>
        </div>
      )}
    </div>
  );
}
